import { defineFeature } from "../core/composition/define-feature.js";
import { parseMultivariantPlaylist } from "../media/hls/parse-multivariant.js";
import { resolvePresentation } from "../behaviors/resolve-presentation.js";
//#region src/playback/features/hls-loading.ts
/** The behaviors the feature composes, in setup order. */
const behaviors = [resolvePresentation];
/** The config defaults the feature contributes. */
const defaultConfig = { parsePresentation: parseMultivariantPlaylist };
/** The state values the feature seeds. */
const initialState = {};
/** Fetches and parses the source's HLS multivariant playlist into the presentation the other features read. */
const hlsLoadingFeature = defineFeature({
	behaviors,
	defaultConfig,
	initialState
});
//#endregion
export { behaviors, defaultConfig, hlsLoadingFeature, initialState };

//# sourceMappingURL=hls-loading.js.map